export const getLocationSearch = state => state.locationSearch.locationSearchData;
export const getLocationSearchLoading = state => state.locationSearch.searchLoading;
export const getError = state => state.locationSearch.error;
export const getClickAndCollectLoading = state => state.locationSearch.loading;